import * as React from "react"

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  headingLevel: `h1` | `h2` | `h3` | `h4` | `h5` | `h6` | `p`
}

const Heading = ({
  headingLevel = `p`,
  children,
  className,
  ...rest
}: HeadingProps) => {
  const TsHeading = ({
    ...props
  }: React.HTMLAttributes<HTMLHeadingElement>) => {
    return React.createElement(headingLevel, props, children)
  }

  return (
    <TsHeading className={className} {...rest}>
      {children}
    </TsHeading>
  )
}

export default Heading
